<template>
  <v-app>
    <toolbar
      :login="login"
      :logout="logout"
      :profile="profile"
      :loggedIn="loggedIn"
      :clientSelection = "client_selection"
      :client_list = "client_list"
      :client_selected = "client_selected"
    />
    
    <v-content>
      
      <v-container>
        <router-view></router-view>
      </v-container>
    </v-content>
    <v-footer app></v-footer>
  </v-app>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex';

  import Toolbar from './components/Toolbar';

  export default {
    name: 'app',

    components: { Toolbar },

    computed: {
      ...mapGetters('user', {
        profile: 'profile',
        loggedIn: 'loggedIn',

      }),
      ...mapGetters('quiz', {
        client_list: 'client_list',
        client_selection: 'client_selection'
      })
    },

    methods: {
      ...mapActions('user', {
        login: 'login',
        logout: 'logout',
      }),
      ...mapActions("quiz",{
        fetch_client_list: "fetch_client_list",
        select_client: "select_client",
        list: "list"

      }),
      client_selected(data){
        console.log(data);
        this.select_client(data)
        this.list()
      },
      

    }
  };
</script>



// WEBPACK FOOTER //
// src/App.vue